export default __webpack_public_path__ + "static/media/masjid-avatar-mobile.7db09fa7.jpg";